import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Section, SectionTitle } from './Section';
import { CTAButton } from '../CTAButton';
import { painPoints } from '../../data/content';
export function PainPoints() {
  return <Section tone="cream" data-id="element-221" data-mp="27n3wcphjma8d">
      <SectionTitle data-id="element-222" data-mp="27oexsinin5wb">Does Any of This Sound Familiar?</SectionTitle>

      <ul className="mt-7 space-y-3" data-id="element-223" data-mp="22usisjtvqpxc">
        {painPoints.map(point => <li key={point} className="flex items-start gap-3 rounded-2xl border border-navy/10 bg-white p-4 text-[14.5px] leading-snug text-navy/80" data-id="element-224" data-mp="2hjp0z9pnhjbo">
            <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-dark" data-id="element-225" data-mp="2qkwlmoz8ulna" />
            {point}
          </li>)}
      </ul>

      <div className="mt-8 rounded-3xl bg-navy p-6 text-center" data-id="element-226" data-mp="2mkmeh8zptp6u">
        <h3 className="font-display text-xl font-bold leading-snug text-white sm:text-2xl" data-id="element-227" data-mp="w6vnk6biq2o9">
          If You Answered "Yes" to Even One of Those…
        </h3>
        <p className="mt-3 text-[15px] leading-relaxed text-white/80" data-id="element-228" data-mp="s7d299fsbpkw">
          The Menopause Clinical Blueprint™ was built specifically for
          physicians like you. Because the difference between uncertainty and
          confidence isn't more information.
        </p>
        <p className="mt-3 font-display text-lg font-bold text-gold sm:text-xl" data-id="element-229" data-mp="1x57q79t76hom">
          It's having the right clinical system.
        </p>
      </div>

      <CTAButton className="mt-8" variant="navy" label="Yes — I want the right clinical system" subline="$27 one-time • 7-day money-back guarantee" data-id="element-230" data-mp="26vsundvjygfg" />
    </Section>;
}